export const isPlainObject = (object) => {
    if (Object.prototype.toString.call(object) !== '[object Object]') {
        return false;
    }
    const prototype = Object.getPrototypeOf(object);
    return prototype === null || prototype === Object.prototype;
};
export const getValidAttributes = (data) => {
    if (!isPlainObject(data)) {
        return {};
    }
    return removePropertiesWithAdvancedTypes(removeEmptyProperties(data));
};
export const removePropertiesWithAdvancedTypes = (data) => {
    const newData = {};
    for (const [key, value] of Object.entries(data)) {
        if (isValidAttributeValue(value)) {
            newData[key] = value;
        }
    }
    return newData;
};
export const removeEmptyProperties = (data) => {
    const newData = { ...data };
    Object.entries(newData).forEach(([propertyKey, propertyValue]) => {
        if (propertyValue === '' || propertyValue === undefined || propertyValue === null) {
            delete newData[propertyKey];
        }
    });
    return newData;
};
export const isValidAttributeValue = (value) => typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
//# sourceMappingURL=attributes.js.map